import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// bridge--auth: the authoritative web→native sign-in/out signal.
//
// Rendered on EVERY page in the native app (see shared/_bridge_auth.html.erb), it reports the
// real session state to native as soon as the page connects. The Android shell uses this to
// drive the auth hand-off (welcome → tab shell on signedIn:true) and the session-expiry bounce
// (tab shell → welcome on signedIn:false), replacing the old fragile URL/cookie heuristics.
//
// Only runs inside Hotwire Native (BridgeComponent no-ops in a normal browser), so it is inert
// on the web. Pairs with BridgeAuthComponent.kt in the Android repo.
//
// businessId is the hashid of the business the session is working in ("" for a consultant
// who hasn't picked a client). When it changes — a consultant switched client, from any tab —
// the shell discards every tab's pages, so no tab keeps showing the previous client.
export default class extends BridgeComponent {
  static component = "auth"
  static values = {
    signedIn: Boolean,
    email: { type: String, default: "" },
    businessId: { type: String, default: "" }
  }

  connect() {
    super.connect()
    this.send("connect", {
      signedIn: this.signedInValue,
      email: this.emailValue,
      businessId: this.businessIdValue
    })
  }
}
